/**
 * 메인: 베스트상품 목록
 *
 *
 */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { strCut, stringToMoneyFormat } from 'utils';
import {
  Content,
  Title,
  Button,
  ProductItem,
  Tabs,
  Slider,
  Row,
  Col,
  Text,
} from 'components';
import { Empty, Tag } from 'antd';
import { StarOutlined, RightOutlined } from '@ant-design/icons';
import { ReviewApi } from 'api';
import { encrypt } from 'utils/Crypto';

/**----------------------------------------
 * [Component] 쇼핑몰 > 메인 > 베스트상품 컴포넌트
 * ----------------------------------------
 */
const BestSellers = ({ products, giftTabs, screenSize }) => {
  /* ===== ROUTE ===== */
  const navigate = useNavigate();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [reviewList, setReviewList] = useState([]);

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: screenSize >= 768 ? 64 : screenSize >= 500 ? 30 : 26,
      lineHeight: screenSize >= 768 ? '88px' : '150%',
    },
    subTitle: {
      fontSize: 18,
      fontWeight: 400,
      lineHeight: '30px',
      color: 'var(--black-color)',
    },

    mainFlexContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },

    bullet: {
      width: 12,
      height: 12,
      borderRadius: '50%',
      border: '3px solid var(--black-color)',
      display: 'inline-block',
      marginRight: 12,
      cursor: 'pointer',
    },
  };

  /* ===== FUNCTION ===== */
  /**
   * 리뷰목록 조회
   * --
   */
  const handleGetReviewList = async () => {
    try {
      const { status, message, data } = await ReviewApi.getReviews({
        best_review: 'Y',
        is_show: 'Y',
        join_tables: `["user"]`,
      });

      if (status !== 200 || !products.length) throw { message };

      const newReview = data
        .slice()
        .sort((a, b) => b.created_at - a.created_at)
        .slice(0, 10)
        .map((review) => ({
          ...review,
          product: products?.find(
            (product) => product?.key === review?.product_id
          ),
        }))
        .filter((review) => review?.product);

      setReviewList(newReview);
    } catch (e) {
      //
    }
  };

  /* ===== HOOKS ===== */
  /*  */
  useEffect(() => {
    if (!products) return;
    handleGetReviewList();
  }, [products]);

  /* ===== RENDER ===== */

  // JSX: start
  return (
    <Content
      maxWidth={1500}
      padding={0}
      style={{
        padding: screenSize >= 768 ? '100px 0' : '80px 0',
        margin: '0 auto',
        width: screenSize >= 768 ? 'calc(100% - 60px)' : 'calc(100% - 30px)',
        overflow: screenSize >= 1500 ? 'hidden' : 'visible',
      }}
      className="bestreview"
    >
      <Content maxWidth={'100%'} padding={0} backgroundColor="none">
        <Title
          style={{ ...styles.title }}
          className="dela-gothic"
          subButton={
            <Button
              className={'goto'}
              type="default"
              onClick={() => navigate(`/mypage/review`)}
            >
              바로가기 <RightOutlined />
            </Button>
          }
        >
          Review
        </Title>

        {/* <Tabs
                items={giftTabs}
                fullscreen={false}
                layoutStyle={{ border: 'none' }}
                style={{
                  fontSize: 24,
                  padding: 0,
                  marginRight: 40,
                  marginTop: 60,
                }}
                textStyle={{
                  fontFamily: `${'Dela Gothic One'}, sans-serif`,
                  padding: 2,
                  lineHeight: '38px',
                }}
                activeColor={'var(--black-color)'}
              /> */}

        <div style={{ marginTop: screenSize >= 768 ? 100 : 30 }}>
          {!reviewList.length ? (
            <Empty description={'등록된 리뷰가 없습니다.'} />
          ) : (
            <Slider
              spaceBetween={
                screenSize >= 1200
                  ? '1.33%'
                  : screenSize >= 768
                  ? '3.33%'
                  : screenSize >= 400
                  ? '2%'
                  : 15
              }
              slidesPerView={'auto'}
              style={{ overflow: 'visible' }}
              itemStyle={{
                width:
                  screenSize >= 1200
                    ? '24%'
                    : screenSize >= 768
                    ? '30%'
                    : screenSize >= 400
                    ? '49%'
                    : '60%',
              }}
              items={reviewList ?? []}
              // items={products}
              modules={['Autoplay']}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              loop={true}
              // onSwiper={(swiper) =>
              //   setSwiperObj((prev) => ({
              //     ...prev,
              //     review: swiper,
              //   }))
              // }
              render={(props, index, state) => (
                <div
                  key={`review_${index}_${props?.review_id}`}
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    navigate(
                      `/products/${encodeURIComponent(
                        encrypt(props?.product_id)
                      )}`
                    )
                  }
                >
                  <ProductItem.Image
                    src={props?.product?.src}
                    hovered={false}
                    noImageStyle={{ background: 'none' }}
                    style={{ cursor: 'pointer' }}
                  />

                  <div className="text">
                    <Text
                      maxLine={2}
                      size={20}
                      weight={700}
                      style={{
                        marginTop: screenSize >= 500 ? 32 : 10,
                        display: screenSize >= 500 ? 'unset' : 'flex',
                        flexDirection: screenSize >= 500 ? 'unset' : 'column',
                        gap: screenSize >= 500 ? 0 : 5,
                      }}
                    >
                      <Tag style={{ width: 'fit-content' }}>BEST</Tag>
                      {props?.product?.title}
                    </Text>
                    <Text
                      size={14}
                      weight={400}
                      color={'#666666'}
                      style={{ marginTop: 8 }}
                      maxLine={2}
                    >
                      {props.review_content}
                    </Text>
                    <div
                      style={{
                        marginTop: 8,
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Text size={14} weight={400} color={'#666666'}>
                        <StarOutlined />
                        {parseFloat(props.review_score).toFixed(1)}
                      </Text>
                      <Text
                        size={12}
                        weight={400}
                        color={'#BBBBBB'}
                        style={{ padding: '0px 12px' }}
                      >
                        |
                      </Text>
                      <Text size={14} weight={400} color={'#666666'}>
                        {props.user.user_account.slice(0, 3)}****
                      </Text>
                    </div>
                  </div>
                </div>
              )}
            />
          )}
        </div>
      </Content>
    </Content>
  ); // JSX: end
};

/* DF */
BestSellers.defaultProps = {
  products: [],
  giftTabs: [],
};
export default BestSellers;
